import {
  createMenu as publicCreateMenu,
  bulkCreateMenus as publicBulkCreateMenus,
  getMenu as publicGetMenu,
  listMenus as publicListMenus,
  queryMenus as publicQueryMenus,
  typedQueryMenus as publicTypedQueryMenus,
  updateMenu as publicUpdateMenu,
  bulkUpdateMenu as publicBulkUpdateMenu,
  updateExtendedFields as publicUpdateExtendedFields,
  deleteMenu as publicDeleteMenu,
  duplicateMenu as publicDuplicateMenu,
  getMenuSiteUrl as publicGetMenuSiteUrl,
  queryMenusSiteUrl as publicQueryMenusSiteUrl,
} from './restaurants-menus-v1-menu-menus.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  MenuQuery,
  MenusQueryBuilder,
  typedQueryMenus as universalTypedQueryMenus,
} from './restaurants-menus-v1-menu-menus.universal.js';
import { onMenuCreated as publicOnMenuCreated } from './restaurants-menus-v1-menu-menus.public.js';
import { onMenuDeleted as publicOnMenuDeleted } from './restaurants-menus-v1-menu-menus.public.js';
import { onMenuUpdated as publicOnMenuUpdated } from './restaurants-menus-v1-menu-menus.public.js';

function customQueryMenus(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryMenus(httpClient)(),
    typedQueryFunction: (query: MenuQuery) =>
      publicTypedQueryMenus(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): MenusQueryBuilder;
  function overloadedQuery(
    query: MenuQuery
  ): ReturnType<typeof universalTypedQueryMenus>;
  function overloadedQuery(query?: MenuQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createMenu: MaybeContext<
  BuildRESTFunction<typeof publicCreateMenu> & typeof publicCreateMenu
> = /*#__PURE__*/ createRESTModule(publicCreateMenu);
export const bulkCreateMenus: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateMenus> & typeof publicBulkCreateMenus
> = /*#__PURE__*/ createRESTModule(publicBulkCreateMenus);
export const getMenu: MaybeContext<
  BuildRESTFunction<typeof publicGetMenu> & typeof publicGetMenu
> = /*#__PURE__*/ createRESTModule(publicGetMenu);
export const listMenus: MaybeContext<
  BuildRESTFunction<typeof publicListMenus> & typeof publicListMenus
> = /*#__PURE__*/ createRESTModule(publicListMenus);
export const updateMenu: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMenu> & typeof publicUpdateMenu
> = /*#__PURE__*/ createRESTModule(publicUpdateMenu);
export const bulkUpdateMenu: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMenu> & typeof publicBulkUpdateMenu
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMenu);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const deleteMenu: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMenu> & typeof publicDeleteMenu
> = /*#__PURE__*/ createRESTModule(publicDeleteMenu);
export const duplicateMenu: MaybeContext<
  BuildRESTFunction<typeof publicDuplicateMenu> & typeof publicDuplicateMenu
> = /*#__PURE__*/ createRESTModule(publicDuplicateMenu);
export const getMenuSiteUrl: MaybeContext<
  BuildRESTFunction<typeof publicGetMenuSiteUrl> & typeof publicGetMenuSiteUrl
> = /*#__PURE__*/ createRESTModule(publicGetMenuSiteUrl);
export const queryMenusSiteUrl: MaybeContext<
  BuildRESTFunction<typeof publicQueryMenusSiteUrl> &
    typeof publicQueryMenusSiteUrl
> = /*#__PURE__*/ createRESTModule(publicQueryMenusSiteUrl);
export const queryMenus: MaybeContext<
  BuildRESTFunction<typeof customQueryMenus> & typeof customQueryMenus
> = /*#__PURE__*/ createRESTModule(customQueryMenus);
/** */
export const onMenuCreated: BuildEventDefinition<typeof publicOnMenuCreated> &
  typeof publicOnMenuCreated = createEventModule(publicOnMenuCreated);
/**
 * Triggered when a menu is deleted.
 */
export const onMenuDeleted: BuildEventDefinition<typeof publicOnMenuDeleted> &
  typeof publicOnMenuDeleted = createEventModule(publicOnMenuDeleted);
/** */
export const onMenuUpdated: BuildEventDefinition<typeof publicOnMenuUpdated> &
  typeof publicOnMenuUpdated = createEventModule(publicOnMenuUpdated);

export {
  SortOrder,
  WebhookIdentityType,
} from './restaurants-menus-v1-menu-menus.universal.js';
export {
  Menu,
  ExtendedFields,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  BusinessLocationDetails,
  ExternalReferenceInfo,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  DeleteOrphanSections,
  MenusDataCloningCompleted,
  CreateMenuRequest,
  CreateMenuResponse,
  BulkCreateMenusRequest,
  BulkCreateMenusResponse,
  BulkCreateMenuResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  GetMenuRequest,
  GetMenuResponse,
  ListMenusRequest,
  CursorPaging,
  ListMenusResponse,
  CursorPagingMetadata,
  Cursors,
  QueryMenusRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  QueryMenusResponse,
  UpdateMenuRequest,
  UpdateMenuResponse,
  BulkUpdateMenuRequest,
  MaskedMenu,
  BulkUpdateMenuResponse,
  BulkMenuResult,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DeleteMenuRequest,
  DeleteMenuResponse,
  RunMenusMultiLocationMigrationRequest,
  RunMenusMultiLocationMigrationResponse,
  UpdateBusinessLocationIdRequest,
  UpdateBusinessLocationIdResponse,
  CloneMenusRequest,
  CloneMenusResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  SyncContentToMultilingualRequest,
  SyncContentToMultilingualResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  DuplicateMenuRequest,
  DuplicateMenuResponse,
  GetMenuSiteUrlRequest,
  GetMenuSiteUrlResponse,
  MenuSiteUrl,
  QueryMenusSiteUrlRequest,
  QueryMenusSiteUrlResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  MenuCreatedEnvelope,
  MenuDeletedEnvelope,
  MenuUpdatedEnvelope,
  BulkCreateMenusOptions,
  ListMenusOptions,
  MenusQueryResult,
  MenusQueryBuilder,
  MenuQuerySpec,
  UpdateMenu,
  BulkUpdateMenuOptions,
  UpdateExtendedFieldsOptions,
  DuplicateMenuOptions,
  QueryMenusSiteUrlOptions,
} from './restaurants-menus-v1-menu-menus.universal.js';
export { utils } from './restaurants-menus-v1-menu-menus.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  MenuQuery,
} from './restaurants-menus-v1-menu-menus.universal.js';
